var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { success as defaultSuccess, error as defaultError, abort as defaultAbort } from './actions'; // to support libraries like redux-act and redux-actions

var normalizeActionType = function normalizeActionType(actionType) {
  return typeof actionType === 'function' ? actionType.toString() : actionType;
};

var getEmptyData = function getEmptyData(multiple) {
  return multiple ? [] : null;
};

var getInitialRequestState = function getInitialRequestState(_ref) {
  var _ref2;

  var dataKey = _ref.dataKey,
      errorKey = _ref.errorKey,
      pendingKey = _ref.pendingKey,
      multiple = _ref.multiple;
  return _ref2 = {}, _defineProperty(_ref2, dataKey, getEmptyData(multiple)), _defineProperty(_ref2, pendingKey, 0), _defineProperty(_ref2, errorKey, null), _ref2;
};

var getInitialState = function getInitialState(state, reducer, config) {
  if (!reducer) {
    return getInitialRequestState(config);
  }

  return _extends({}, getInitialRequestState(config), reducer(undefined, {}));
};

var defaultConfig = {
  success: defaultSuccess,
  error: defaultError,
  abort: defaultAbort,
  dataKey: 'data',
  errorKey: 'error',
  pendingKey: 'pending',
  multiple: false,
  getData: function getData(state, action) {
    return action.payload ? action.payload.data : action.data;
  },
  getError: function getError(state, action) {
    return action.payload ? action.payload : action.error;
  },
  onRequest: function onRequest(state, action, _ref3) {
    var _extends2;

    var pendingKey = _ref3.pendingKey,
        errorKey = _ref3.errorKey;
    return _extends({}, state, (_extends2 = {}, _defineProperty(_extends2, pendingKey, state[pendingKey] + 1), _defineProperty(_extends2, errorKey, null), _extends2));
  },
  onSuccess: function onSuccess(state, action, config) {
    var _extends3;

    var dataKey = config.dataKey,
        pendingKey = config.pendingKey,
        errorKey = config.errorKey,
        getData = config.getData;
    return _extends({}, state, (_extends3 = {}, _defineProperty(_extends3, dataKey, getData(state, action, config)), _defineProperty(_extends3, pendingKey, state[pendingKey] - 1), _defineProperty(_extends3, errorKey, null), _extends3));
  },
  onError: function onError(state, action, config) {
    var _extends4;

    var dataKey = config.dataKey,
        multiple = config.multiple,
        pendingKey = config.pendingKey,
        errorKey = config.errorKey,
        getError = config.getError;
    return _extends({}, state, (_extends4 = {}, _defineProperty(_extends4, dataKey, getEmptyData(multiple)), _defineProperty(_extends4, pendingKey, state[pendingKey] - 1), _defineProperty(_extends4, errorKey, getError(state, action, config)), _extends4));
  },
  onAbort: function onAbort(state, action, _ref4) {
    var pendingKey = _ref4.pendingKey;
    return _extends({}, state, _defineProperty({}, pendingKey, state[pendingKey] - 1));
  },
  resetOn: []
};
export var createRequestsReducer = function createRequestsReducer() {
  var globalConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (localConfig) {
    var reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return function (state, action) {
      var config = _extends({}, defaultConfig, globalConfig, localConfig);

      var nextState = state === undefined ? getInitialState(state, reducer, config) : state;
      var onRequest = config.onRequest,
          onSuccess = config.onSuccess,
          onError = config.onError,
          onAbort = config.onAbort,
          success = config.success,
          error = config.error,
          abort = config.abort,
          resetOn = config.resetOn,
          pendingKey = config.pendingKey,
          actionType = config.actionType;
      var normalizedActionType = normalizeActionType(actionType);

      if (typeof resetOn === 'function' && resetOn(action) || typeof resetOn !== 'function' && resetOn.map(normalizeActionType).includes(action.type)) {
        return _extends({}, getInitialState(state, reducer, config), _defineProperty({}, pendingKey, state[pendingKey]));
      }

      switch (action.type) {
        case normalizedActionType:
          return onRequest(state, action, config);

        case success(normalizedActionType):
          return onSuccess(state, action, config);

        case error(normalizedActionType):
          return onError(state, action, config);

        case abort(normalizedActionType):
          return onAbort(state, action, config);

        default:
          return reducer ? reducer(nextState, action) : nextState;
      }
    };
  };
};
export var requestsReducer = createRequestsReducer();